






















import { Vue, Component, Prop } from 'vue-property-decorator';
import PopupBannerDescription from '@/components/banner/popup/PopupBannerDescription.vue';
import { BannerDescriptionPopupProp } from '@/types/banner';

@Component({
  components: {
    PopupBannerDescription,
  },
})
export default class ControllerBannerDescription extends Vue {
  @Prop({ default: '' }) private readonly descriptionData: string;
  @Prop({ default: '#ffffff' }) private readonly defaultColorHexCode: string;

  private popupTitle: string = this.$t('BANNER_LIST_ADD_BANNER_DESCRIPTION').toString();
  private isEnablePopup: boolean = false;

  get hasDescriptionData(): boolean {
    return !!this.descriptionData;
  }

  private onClickAdd(): void {
    this.enablePopup('add');
  }

  private onClickUpdate(): void {
    this.enablePopup('update');
  }

  private onClickDelete(): void {
    this.$emit('onDelete');
    this.disablePopup();
  }

  public enablePopup(type: 'add' | 'update'): void {
    switch (type) {
      case 'add':
        this.popupTitle = this.$t('BANNER_LIST_ADD_BANNER_DESCRIPTION').toString();
        break;
      case 'update':
        this.popupTitle = this.$t('BANNER_LIST_UPDATE_BANNER_DESCRIPTION').toString();
        break;
    }

    this.isEnablePopup = true;
  }

  public disablePopup(): void {
    this.isEnablePopup = false;
  }

  public onChangeData(data: BannerDescriptionPopupProp): void {
    this.$emit('onSubmit', data);
  }
}
